module.exports = __webpack_public_path__ + "static/media/359.20466b94.png";